import { noPreview } from "owa-locstrings/lib/strings/getCleanPreview.locstring.json";
import loc from "owa-localize";

// The server caps the body preview at 255 characters. A snippet that reaches
// the cap was capped, but in a multi-line preview it can still fit without overflowing
// — so `text-overflow: ellipsis` never trips and we append one ourselves.
const PREVIEW_TEXT_MAX_LENGTH = 255;

// Matches a trailing ellipsis the snippet may already end with
function endsWithEllipsis(text: string): boolean {
    return /(?:…|\.{3,})$/.test(text);
}

export default function getCleanPreview(preview?: string, addEllipsis: boolean = false): string {
    preview = preview || "";
    
    const isCapped = preview.length >= PREVIEW_TEXT_MAX_LENGTH;
    
    const underscoreIndex = preview.indexOf("_____");
    
    // A run of _____ usually marks where this message ends and a quoted/forwarded one
    // begins, so keep only the part before it.
    if (underscoreIndex >= 0) {
        preview = preview.slice(0, underscoreIndex);
    }
    
    // Strip artifacts from when an HTML/decorated email is flattened to a plain-text preview
    preview = preview.replace(/¯/g, "").replace(/--/g, "").replace(/\s\s+/g, " ").trim();
    
    if (preview.length === 0) {
        return loc(noPreview);
    }
    
    // Append an ellipsis to a capped snippet to indicate the message continues, without
    // trimming the trailing partial word. Skip if it was cut at a message boundary
    // (underscores, handled above) or already ends in an ellipsis so we never double up.
    if (addEllipsis && isCapped && underscoreIndex < 0 && !endsWithEllipsis(preview)) {
        preview = preview + "\u2026";
    }
    
    return preview;
}
